import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import {
  ReportInformationNewCompany,
  ReportInformationOtherReportCompany,
  StatisticsReport,
} from '@core/models';
import { environment } from '@env/environment';
import { FilterReportsInterface } from '@report/interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  getReports() {
    return this.http.get<{ messages: string; data: StatisticsReport }>(
      `${environment.API_URI}/reports`,
    );
  }

  getInfoReport(data: FilterReportsInterface) {
    const { periodEnd, periodInitial, typeReport, userId, skip, limit } = data;

    let params = new HttpParams()
      .set('periodEnd', periodEnd)
      .set('periodInitial', periodInitial)
      .set('typeReport', typeReport)
      .set('skip', skip)
      .set('limit', limit);

    if (userId !== '') {
      params = params.set('userId', userId);
    }

    return this.http.get<{
      total: number;
      messages: string;
      data:
        | ReportInformationNewCompany[]
        | ReportInformationOtherReportCompany[];
    }>(`${environment.API_URI}/reports/information`, {
      params,
    });
  }

  downloadReport(
    data: Omit<FilterReportsInterface, 'skip' | 'limit'>,
  ): Observable<HttpResponse<Blob>> {
    const headers = new HttpHeaders();
    headers.set(
      'Accept',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    );
    const { periodEnd, periodInitial, typeReport, userId } = data;

    let params = new HttpParams()
      .set('periodEnd', periodEnd)
      .set('periodInitial', periodInitial)
      .set('typeReport', typeReport);

    if (userId !== '') {
      params = params.set('userId', userId);
    }

    return this.http.get(`${environment.API_URI}/reports/excel`, {
      headers,
      observe: 'response',
      responseType: 'blob',
      params,
    });
  }

  downloadGlobalReport(
    data: Omit<FilterReportsInterface, 'typeReport' | 'skip' | 'limit'>,
  ): Observable<HttpResponse<Blob>> {
    const headers = new HttpHeaders();
    headers.set(
      'Accept',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    );
    const { periodEnd, periodInitial, userId } = data;

    let params = new HttpParams()
      .set('periodEnd', periodEnd)
      .set('periodInitial', periodInitial);

    if (userId !== '') {
      params = params.set('userId', userId);
    }

    return this.http.get(`${environment.API_URI}/reports/global/excel`, {
      headers,
      observe: 'response',
      responseType: 'blob',
      params,
    });
  }
}
